import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./index.module.less";
import classNames from "classnames";
export const BDotText = ({ wrapperClass, content, }) => {
    return (_jsx("span", { className: classNames(styles["b-dot-text"], wrapperClass), children: content.filter(Boolean).map((item, idx) => (_jsxs(React.Fragment, { children: [typeof item === "string" ? (item) : (_jsx("span", { className: item?.className ?? "", children: item?.text })), idx < content.length - 1 && _jsx("span", { children: " \u00B7 " })] }, idx))) }));
};
BDotText.displayName = "BDotText";
